import React from "react";
import NewsCarousel from '../Sites/Startseite/NewsCarousel/NewsCarousel'
import styles from "./home.module.css";
import HeroBanner from "../components/HeroBanner/HeroBanner";
import MainInformation from "../components/MainInformation/MainInformation";
import AnzeigenSaeuleRow from "../components/AnzeigenSaeule/AnzeigenSaeuleRow";
import { Icons } from "../../code/IconHandler";
import AlertBanner from "../components/Banner/AlertBanner/AlterBanner";
function Home() {
    const list1 = [
        {
            "icon": Icons.Contact,
            "iconAlt": "Eine Vesitenkarte als Icon",
            "text_html": "<div><h3>Werde Mitglied!</h3><p>Alle Informationen findest du hier.</p></div><a href='/werde-teil-von-uns'>Werde Teil von Uns!</a>"
        },
        {
            "icon": Icons.Freiwilligkeit,
            "iconAlt": "Hand mit Herz als Icon",
            "text_html": "<div><h3>Ehrenamt</h3><p>Wir freuen uns um jeden Helfer und jeder Helferin.</p></div><a href='/werde-teil-von-uns#ehrenamt'>Infos: Ehrenamt</a></div>"
        },
        // {
        //     "icon": Icons.Question,
        //     "iconAlt": "Fragezeichen als Icon",
        //     "text_html": "<div><h3>Du hast Fragen?</h3><p>Melde dich gerne bei uns!</p></div><a href='/unser-verein/tus-05-organisation#geschaeftsstelle'>Zur Geschäftsstelle</a></div>"
        // },
        // {
        //     "text_html": "<div style='display:grid;grid-template-rows:1fr auto auto;align-items:space-between;gap:6x;justify-items:space-between;box-sizing:border-box;'><img src='/assets/icons/DOSB-Signet_SPG_2021_Farbe_rgb.png' alt='Sportsiegel' style='width:100%;height:100%;object-fit:contain;display:block;' /><h3 style='margin:0;text-align:center;'>Wir halten euch fit! 🎉</h3><a href='/gesundheitssport' style='text-align:center;'>Unsere Angebote</a></div>"
        // },
        {
            "icon": '/assets/icons/DOSB-Signet_SPG_2021_Farbe_rgb.png',
            "iconBig": true,
            "iconAlt": "Fragezeichen als Icon",
            "text_html": "<div><h3>Wir halten euch fit! 🎉</h3></div><a href='/gesundheitssport'>Unsere Angebote</a></div>"
        },
        {
            "icon": '/assets/icons/uhlsport_logo.png',

            "iconAlt": "Uhlsport Logo",
            "text_html": "<div><h3>Neue Klamotten vom TuS!</h3><p>Schaut gerne mal vorbei.</p></div><a href='https://clubshop.uhlsport.com/tus-oberpleis/'>Club - Shop</a>"
        }
    ]
    const list2 = [
        {
            "icon": "/images/shop/peter-metzler_logo.png",
            "iconAlt": "Team Sport Metzler Logo",
            "text_html": "<div><h3>Unser Partner</h3><p>Hier lässt sich Einiges finden!</p></div><a href='https://www.team-sport-metzler.de'>Team-Sport Metzler!</a>"
        },
        {
            "icon": Icons.Policy,
            "iconAlt": "Richtlinien als Logo",
            "text_html": "<div><h3>Unsere Leitlinie</h3><p>Hier nach möge sich Jede:r richten.</p></div><a href='/unser-verein/tus-05-organisation#leitbild'>Zur Leitlinie</a></div>"
        },
        {
            "icon": Icons.Stellenangebot,
            "iconAlt": "Vertrag als Icon",
            "text_html": "<div><h3>Stellenangebote</h3><p>Schau nach was gerade offen ist!</p></div><a href='/werde-teil-von-uns#stellenausschreibungen'>Stellenangebote</a></div>"
        },
        {
            "icon": Icons.World,
            "iconAlt": "Welt Logo",
            "text_html": "<div><h3>Nachhaltigkeit</h3><p>So wollen wir uns verbessern!</p></div><a href='/unser-verein/nachhaltigkeit-beim-tus'>Mehr Infos</a>"
        }
    ]
    return (
        <div className={styles.container}>
            <HeroBanner category="startseite" />
            <MainInformation />
            <AlertBanner />
            <AnzeigenSaeuleRow list={list1} />
            <NewsCarousel />
            <AnzeigenSaeuleRow list={list2} />
        </div>
    );
}

export default Home;
